import { IAPICodeDTO, IApiSuccessWrapper, IExportStatus } from '$/types'
import { apiSlice } from 'app/services/api'

export interface IEventTableMeta {
  id: number
  name: string
  entity: string
  eventTableAttributes: IEventTableAttributes[]
  dataManagementCategory: IDataManagementCategory
  arcGisUrl: string
  typeCode?: 'Linear' | 'Point'
}

export interface IEventTableExportParams {
  eventTableList: IEventTableMeta[]
  tableType: string
  exportDate: string | undefined
  exportOption: string
}

export interface IEventTableAttributes {
  id: string
  name: string
  code: string
  eventTableId: string
  dataType: 'string' | 'int' | 'float' | 'bit'
  // Data View only?
  minValue?: number
  maxValue?: number
  attributeEnums?: IAPICodeDTO[]
  // Data View column definition support properties
  isHidden?: boolean
  isPinned?: boolean
  isSorted?: boolean
}

interface IDataManagementCategory {
  id: string
  categoryName: string
}

export const eventTablesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getEventTablesForDataView: build.query<IEventTableMeta[], void>({
      query: () => ({
        method: 'GET',
        url: '/datamanagement/tableattributes',
        params: {
          param: 'dataview'
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IEventTableMeta[]
      }
    }),
    getEventTablesForExport: build.query<IEventTableMeta[], void>({
      query: () => ({
        method: 'GET',
        url: '/datamanagement/tableattributes',
        params: {
          param: 'export'
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IEventTableMeta[]
      }
    }),
    getEventTablesForImport: build.query<IEventTableMeta[], void>({
      query: () => ({
        method: 'GET',
        url: '/datamanagement/tableattributes',
        params: {
          param: 'import'
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IEventTableMeta[]
      }
    }),
    addEventTablesExportJob: build.mutation<
      IExportStatus,
      IEventTableExportParams
    >({
      query: ({ eventTableList, tableType, exportDate, exportOption }) => ({
        method: 'POST',
        url: '/datamanagement/export/eventtable',
        body: {
          eventTableList,
          tableType,
          exportDate,
          exportOption
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IExportStatus
      }
    }),
    addCodeGuideForExportJob: build.mutation({
      query: () => ({
        method: 'POST',
        url: '/datamanagement/export/codeguide'
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IExportStatus
      }
    })
  })
})

export const {
  useGetEventTablesForDataViewQuery,
  useGetEventTablesForExportQuery,
  useGetEventTablesForImportQuery,
  useAddEventTablesExportJobMutation,
  useAddCodeGuideForExportJobMutation
} = eventTablesApi
